var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "projects-page-outer" },
    [
      _c(
        "div",
        {
          class: { "is-blurred": _vm.isLoading },
          attrs: { id: "projects-page" }
        },
        [
          _c("TheLiteModal"),
          _vm._v(" "),
          _c("TheLiteNavbar"),
          _vm._v(" "),
          _c("div", { attrs: { id: "configurator-group-lite" } }, [
            _vm.openSidebar
              ? _c(
                  "div",
                  { staticClass: "sidenav sidenav-lite" },
                  [
                    _c(
                      "vue-custom-scrollbar",
                      { staticClass: "lite-sidebar-upper" },
                      [_c("router-view", { attrs: { name: "sidebar" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "lite-sidebar-lower" },
                      [
                        _c("router-view", {
                          attrs: { name: "lowerBarRight", version: "lite" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "workspace-group" } },
              [
                _c(
                  "div",
                  { attrs: { id: _vm.workspaceID } },
                  [_c("router-view", { attrs: { name: "workspace" } })],
                  1
                ),
                _vm._v(" "),
                _c("router-view", { attrs: { name: "lowerBarLight" } })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }